import { External_Mappings } from "./external-source-charge-mapping.model";

export interface IChargeMasterModel {
    id?: string,
    is_active?: boolean;
    description?: string;
    charge_code?: number;
    charge_head?: string,
    print_name?: string;
    is_grouped?: boolean;
    is_incidental?: boolean;
    organization?: string;
    charge_category?: any;
    charge_group?: any;
    receivable_payable?: string[];
    charge_expense?: string;
    charge_revenue?: string;
    company?: string;
    uom?: string[];
    hsn_code?: null;

    is_time_based: boolean;
    departments: any[];
    exclude_users: any[];
    applicability: string;
    external_mappings: Array<External_Mappings>;
    is_rcm_applicable: boolean;
    is_amount_editable:boolean;
}

export interface ChargeMasterError {
    is_active: string[];
    description: string[];
    charge_code: string[];
    charge_head: string[];
    print_name: string[];
    is_grouped: string[];
    is_incidental: string[];
    organization: string[];
    charge_category: string[];
    charge_group: string[];
    receivable_payable: string[];
    charge_expense: string[];
    charge_revenue: string[];
    company: string[];
    uom: string[];
    hsn_code: string[];

    is_time_based: string[];
    departments: string[];
    exclude_users: string[];
    applicability: string[];
    external_mappings: string[];
    is_rcm_applicable: string[];
    is_amount_editable:string[];
}


export class ChargeMasterModel implements IChargeMasterModel {
    id?: string;
    is_active?: boolean;
    description?: string;
    charge_code?: number;
    charge_head?: string;
    print_name?: string;
    is_grouped?: boolean;
    is_incidental?: boolean;
    organization?: string;
    charge_category?: any;
    charge_group?: any;
    receivable_payable?: any;
    charge_expense?: string;
    charge_revenue?: string;
    company?: string;
    uom?: any;
    hsn_code?: any;
    is_time_based: boolean;
    departments: any[];
    exclude_users: any[];
    applicability: string;
    external_mappings: External_Mappings[];
    is_rcm_applicable: boolean;
    is_amount_editable:boolean;
    errors: ChargeMasterError;

    constructor() {
        this.id = null;
        this.is_active = true;
        this.description = null;
        this.charge_code = null;
        this.charge_head = null;
        this.print_name = null;
        this.is_grouped = false;
        this.is_incidental = false;
        this.organization = null;
        this.charge_category = null;
        this.charge_group = null;
        this.receivable_payable = null;
        this.charge_expense = null;
        this.charge_revenue = null;
        this.company = null;
        this.uom = null;
        this.hsn_code = null;
        this.is_time_based = false;
        this.departments = [];
        this.exclude_users = [];
        this.applicability = null;
        this.external_mappings = [new External_Mappings()];
        this.is_rcm_applicable = false;
        this.is_amount_editable = false;
        this.resetErrors();
    }

    resetErrors() {
        this.errors = {
            is_active: [],
            description: [],
            charge_code: [],
            charge_head: [],
            print_name: [],
            is_grouped: [],
            is_incidental: [],
            organization: [],
            charge_category: [],
            charge_group: [],
            receivable_payable: [],
            charge_expense: [],
            charge_revenue: [],
            company: [],
            uom: [],
            hsn_code: [],
            is_time_based: [],
            departments: [],
            exclude_users: [],
            applicability: [],
            external_mappings: [],
            is_rcm_applicable: [],
            is_amount_editable:[],
        }
    }

    setErrors(err) {
        this.errors.is_active = err.is_active ? err.is_active : [];
        this.errors.description = err.description ? err.description : [];
        this.errors.charge_code = err.charge_code ? err.charge_code : [];
        this.errors.charge_head = err.charge_head ? err.charge_head : [];
        this.errors.print_name = err.print_name ? err.print_name : [];
        this.errors.is_grouped = err.is_grouped ? err.is_grouped : [];
        this.errors.is_incidental = err.is_incidental ? err.is_incidental : [];
        this.errors.organization = err.organization ? err.organization : [];
        this.errors.charge_category = err.charge_category ? err.charge_category : [];
        this.errors.charge_group = err.charge_group ? err.charge_group : [];
        this.errors.receivable_payable = err.receivable_payable ? err.receivable_payable : [];
        this.errors.charge_expense = err.charge_expense ? err.charge_expense : [];
        this.errors.charge_revenue = err.charge_revenue ? err.charge_revenue : [];
        this.errors.company = err.company ? err.company : [];
        this.errors.uom = err.uom ? err.uom : [];
        this.errors.hsn_code = err.hsn_code ? err.hsn_code : [];
        this.errors.is_time_based = err.is_time_based ? err.is_time_based : [];
        this.errors.departments = err.departments ? err.departments : [];
        this.errors.exclude_users = err.exclude_users ? err.exclude_users : [];
        this.errors.applicability = err.applicability ? err.applicability : [];
        this.errors.external_mappings = err.external_mappings ? err.external_mappings : [];
        this.errors.is_rcm_applicable = err.is_rcm_applicable ? err.is_rcm_applicable : [];
        this.errors.is_amount_editable = err.is_amount_editable ? err.is_amount_editable :[];
    }

    checkStepOneForErrors() {
        return this.errors.description.length == 0
            && this.errors.charge_code.length == 0
            && this.errors.charge_head.length == 0
            && this.errors.print_name.length == 0
            && this.errors.organization.length == 0
            && this.errors.charge_category.length == 0
            && this.errors.charge_group.length == 0
            && this.errors.receivable_payable.length == 0
            && this.errors.charge_expense.length == 0
            && this.errors.charge_revenue.length == 0
            && this.errors.company.length == 0
            && this.errors.uom.length == 0
            && this.errors.hsn_code.length == 0
            && this.errors.applicability.length == 0
    }

    checkUserChargeForErrors() {
        return this.errors.departments.length == 0
            && this.errors.exclude_users.length == 0
    }

    checkESCIForErrors() {
        return this.errors.external_mappings.length == 0
    }

    savePayloadToModel(data) {
        this.id = data.id;
        this.is_active = data.is_active;
        this.description = data.description;
        this.charge_code = data.charge_code;
        this.charge_head = data.charge_head;
        this.print_name = data.print_name;
        this.is_grouped = data.is_grouped;
        this.is_incidental = data.is_incidental;
        this.organization = data.organization;
        this.charge_category = data.charge_category;
        this.charge_group = data.charge_group;
        this.receivable_payable = data.receivable_payable;
        this.charge_expense = data.charge_expense;
        this.charge_revenue = data.charge_revenue;
        this.company = data.company;
        this.uom = data.uom;
        this.hsn_code = data.hsn_code;
        this.is_time_based = data.is_time_based;
        this.departments = data.departments;
        this.exclude_users = data.exclude_users;
        this.applicability = data.applicability;
        this.is_rcm_applicable = data.is_rcm_applicable;
        this.is_amount_editable = data.is_amount_editable
        if (data.external_mappings.length > 0) {
            for (let i = 0; i < data.external_mappings.length; i++) {
                this.external_mappings[i] = new External_Mappings();
                this.external_mappings[i].savePayloadToModel(data.external_mappings[i]);
            }
        }
    }

    getStepOneSavePayload() {
        return {
            id: this.id,
            is_active: this.is_active,
            description: this.description,
            charge_code: this.charge_code,
            charge_head: this.charge_head,
            print_name: this.print_name,
            is_grouped: this.is_grouped,
            is_incidental: this.is_incidental,
            organization: this.organization,
            charge_category: typeof this.charge_category == 'object' && this.charge_category != null ? this.charge_category.id : this.charge_category,
            charge_group: typeof this.charge_group == 'object' && this.charge_group != null ? this.charge_group.id : this.charge_group,
            receivable_payable: typeof this.receivable_payable == 'object' && this.receivable_payable != null ? this.receivable_payable.id : this.receivable_payable,
            charge_expense: this.charge_expense,
            charge_revenue: this.charge_revenue,
            company: this.company,
            uom: typeof this.uom == 'object' && this.uom != null ? this.uom.id : this.uom,
            hsn_code: typeof this.hsn_code == 'object' && this.hsn_code != null ? this.hsn_code.id : this.hsn_code,
            is_time_based: this.is_time_based,
            applicability: this.applicability,
            is_rcm_applicable: this.is_rcm_applicable,
            is_amount_editable: this.is_amount_editable
        }
    }

    getUserChargeSavePayload() {
        return {
            departments: this.departments.length ? this.departments.map((item) => item.id) : [],
            exclude_users: this.exclude_users?.length ? this.exclude_users.map((item) => item.id) : [],
        }
    }

    getESCISavePayload() {
        return {
            external_mappings: this.external_mappings.length ? this.external_mappings.map(item => item.getPostPayload()) : [],
        }
    }
}